import type { FC } from 'react'
import { useState } from 'react'

import VerifyButton from '@/components/VerifyButton'
import type { Address } from '@/types/Activity'

import VerifyAddressSidebar from './Sidebar'

interface Props {
  customerId: string
  subjectId: string
  address: Address
  disabled?: boolean
}

const VerifyAddress: FC<Props> = ({ customerId, subjectId, address, disabled }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false)

  const isDisabled =
    address.status !== 'Renting' ||
    (address.verification !== null &&
      address.verification !== undefined &&
      address.verification.state !== 'notVerified') ||
    disabled === true

  return (
    <>
      {isSidebarOpen && (
        <VerifyAddressSidebar
          customerId={customerId}
          subjectId={subjectId}
          onClose={() => setIsSidebarOpen(false)}
          address={address}
        />
      )}
      <VerifyButton onClick={() => setIsSidebarOpen(true)} disabled={isDisabled} />
    </>
  )
}

export default VerifyAddress
